import React from "react";
import ButtonCustom from "./ButtonCustom";
import { blueButton, yellowButton } from "src/shared/styles/buttonStyles";
import CalendarioIcon from "src/shared/icons/CalendarioIcon";
import SvgIcon from "@mui/icons-material/TouchApp";

const SearchHoursSiteOficialNuevo = (props) => {
  return (
    <ButtonCustom
      {...props}
      style={{ ...blueButton, height: "35px" }}
      text="Agendar Hora"
      icon={
        <SvgIcon>
          <CalendarioIcon />
        </SvgIcon>
      }
    ></ButtonCustom>
  );
};

export default SearchHoursSiteOficialNuevo;
